import { ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1529220e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "name-cell"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'LogDetailModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    dataSource: null
  },
  emits: ['update:modalVisible'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const columns = [{
      title: '参数',
      dataIndex: 'name',
      key: 'name'
    }, {
      title: '调整前',
      dataIndex: 'oldValue',
      key: 'oldValue'
    }, {
      title: '调整后',
      dataIndex: 'newValue',
      key: 'newValue'
    }];
    const visible = ref(false);
    const closeModal = () => {
      emit('update:modalVisible', false);
    };
    watch(() => props.modalVisible, n => {
      visible.value = n;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "日志审查",
        onCancel: closeModal,
        onOk: closeModal,
        centered: "",
        open: visible.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => visible.value = $event),
        width: "1050px"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_table, {
          bordered: "",
          columns: columns,
          rowKey: "id",
          "data-source": __props.dataSource,
          pagination: false,
          ref: "tableRef",
          scroll: {
            y: 600
          }
        }, {
          bodyCell: _withCtx(({
            column,
            record
          }) => [column.key === 'oldValue' || column.key === 'newValue' ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(record[column.key]), 1)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["data-source"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});